import React from 'react';

import { Button } from 'design-system-web';
import { Alert, AlertType } from 'components/lds';
import { S } from 'components/typography';

import { useNavigationCommands } from '../../commands/CustomizationCommandsContext';
import { useLabels } from '../../i18n/useLabels';
import type {
  RecoveryBannerKind,
  RecoveryBannerViewModel,
} from '../../viewmodels/resolveRecoveryBanner';

import styles from './RecoveryBanner.scss';

type Props = {
  viewModel: RecoveryBannerViewModel;
};

const ALERT_TYPE_BY_KIND: Record<RecoveryBannerKind, AlertType> = {
  outcomeUnknown: AlertType.warning,
  refreshFailed: AlertType.error,
};

export function RecoveryBanner({ viewModel }: Props) {
  const { refresh } = useNavigationCommands();
  const { formatMessage } = useLabels();

  return (
    <div data-test={viewModel.testId} role="status" className={styles.banner}>
      <Alert type={ALERT_TYPE_BY_KIND[viewModel.kind]} fullWidth>
        <div className={styles.content}>
          <S bold>{formatMessage(viewModel.title)}</S>
          <S>{formatMessage(viewModel.body)}</S>
          <Button
            variant="secondary"
            loading={viewModel.busy}
            onClick={refresh}
          >
            {formatMessage(viewModel.actionLabel)}
          </Button>
        </div>
      </Alert>
    </div>
  );
}
